import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../base-types";
import Link from "../link";
import { MemberGroupResource } from "./member-group-resource";
import Resource from "./resource";

@JsonObject()
export class EntityDefinitionResource extends Resource {
    @JsonProperty("id")
    readonly id: number;

    @JsonProperty("name")
    name: string;

    @JsonProperty("created_on")
    createdOn: Date;

    @JsonProperty("modified_on")
    modifiedOn: Date;

    @JsonProperty("display_template")
    displayTemplate: string;

    @JsonProperty("is_taxonomy_item_definition")
    isTaxonomyItemDefinition: boolean;

    @JsonProperty("is_path_enabled_definition")
    isPathEnabledDefinition: boolean;

    @JsonProperty("is_manual_sorting_allowed")
    isManualSortingAllowed: boolean;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("is_light")
    isLight: boolean;

    @JsonProperty("usage_type")
    usageType: string;

    @JsonProperty("labels")
    labels: MapCultureTo<string> = {};

    @JsonProperty("member_groups")
    @JsonElementType(MemberGroupResource)
    memberGroups: Array<MemberGroupResource> = [];

    @JsonProperty("permissions")
    @JsonElementType(String)
    permissions?: Array<string>;

    //#region Links

    @JsonProperty("entities")
    entities: Link;

    @JsonProperty("related_paths")
    relatedPaths: Link;

    @JsonProperty("created_by")
    createdBy: Link;

    @JsonProperty("modified_by")
    modifiedBy: Link;

    //#endregion

    constructor(init?: Partial<EntityDefinitionResource>) {
        super();
        Object.assign(this, init);
    }
}
